(() => {
  'use strict';

  // 卖点按变体切换。每条卖点自带 visibility(逗号分隔多个选项值, 留空 = 所有变体都显示)。
  // 匹配逻辑与套装抽屉(product-set-dialog.js)一致: normaliseKey 鲁棒归一。
  const normaliseKey = (value) => String(value ?? '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '');
  const CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.3" stroke="#00a5c3"/><path d="M4.6 8.2 7 10.6l4.4-4.8" stroke="#00a5c3" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const init = (scope = document) => {
    scope.querySelectorAll('[data-selling-point-sets]').forEach((root) => {
      if (root.dataset.sellingPointSetsReady === 'true') return;
      root.dataset.sellingPointSetsReady = 'true';

      let config;
      try {
        config = JSON.parse(root.querySelector('[data-selling-point-sets-config]')?.textContent || 'null');
      } catch (error) {
        return;
      }
      if (!config) return;

      const view = root.querySelector('[data-selling-point-sets-view]');
      if (!view) return;

      // 区块兜底列表(liquid 渲染, 无元数据的变体切到这里)
      const fallback = root.querySelector('[data-selling-point-sets-fallback]');

      const selectedOptions = Array.isArray(config.selectedOptions) ? config.selectedOptions.slice() : [];

      const matchesCurrent = (variant) => {
        const options = Array.isArray(variant?.options) && variant.options.length ? variant.options : selectedOptions;
        if (variant?.options) selectedOptions.splice(0, selectedOptions.length, ...variant.options);
        // 匹配任何一个选项值: 适用选项填 "1x BP5000" / "Balkon" / "2000Wp – 4 Module 🔥" 都行
        const keys = options.map((option) => normaliseKey(option)).filter(Boolean);
        return config.entries.filter((entry) => {
          const visibilityKeys = String(entry.visibility ?? '')
            .split(',')
            .map((part) => normaliseKey(part))
            .filter(Boolean);
          // 留空 = 所有变体都显示
          return visibilityKeys.length === 0 || visibilityKeys.some((key) => keys.includes(key));
        });
      };

      const createItem = (entry) => {
        const item = document.createElement('li');
        item.className = 'product-selling-points__item';
        const icon = document.createElement('span');
        icon.className = 'product-selling-points__icon';
        icon.setAttribute('aria-hidden', 'true');
        if (entry.icon) {
          const img = document.createElement('img');
          img.src = entry.icon;
          img.alt = '';
          img.loading = 'lazy';
          icon.append(img);
        } else {
          icon.innerHTML = CHECK_SVG;
        }
        const label = document.createElement('span');
        label.className = 'product-selling-points__text';
        label.textContent = entry.text;
        item.append(icon, label);
        return item;
      };

      const render = (entries) => {
        const points = (entries || []).filter((entry) => entry?.text);
        if (points.length === 0) {
          // 该变体无元数据 → 回落到区块兜底列表; 连兜底也没有才整体隐藏
          view.replaceChildren();
          if (fallback && fallback.childElementCount > 0) {
            view.hidden = true;
            fallback.hidden = false;
            root.hidden = false;
          } else {
            root.hidden = true;
          }
          return;
        }
        root.hidden = false;
        view.hidden = false;
        if (fallback) fallback.hidden = true;
        const list = document.createElement('ul');
        list.className = 'product-selling-points__list';
        list.setAttribute('role', 'list');
        points.forEach((entry) => list.append(createItem(entry)));
        view.replaceChildren(list);
      };

      if (config.mode === 'variant') {
        const variants = Array.isArray(config.variants) ? config.variants : [];
        const entriesForVariant = (variantId) => {
          const match = variants.find((item) => String(item.id) === String(variantId));
          const points = Array.isArray(match?.points) ? match.points.filter(Boolean) : [];
          return points
            .map((point) => typeof point === 'string'
              ? { text: point, icon: '' }
              : { text: String(point?.text || ''), icon: String(point?.icon || '') })
            .filter((point) => point.text);
        };

        render(entriesForVariant(config.selectedVariantId));
        const eventScope = root.closest('product-info') || document;
        eventScope.addEventListener('variant:change', (event) => {
          render(entriesForVariant(event.detail?.variant?.id));
        });
        return;
      }

      if (!Array.isArray(config.entries) || config.entries.length === 0) return;

      // 初次运行: 服务端是精确匹配, 这里用鲁棒匹配统一校正一遍
      render(matchesCurrent(null));

      const eventScope = root.closest('product-info') || document;
      eventScope.addEventListener('variant:change', (event) => {
        render(matchesCurrent(event.detail?.variant));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
